<div><ng-content select="mat-card-title, mat-card-subtitle,
      [mat-card-title], [mat-card-subtitle],
      [matCardTitle], [matCardSubtitle]"></ng-content></div><ng-content select="img"></ng-content><ng-content></ng-content>